<ng-container *appTranslate="let t">
  <ng-container *ngIf="!settingsService.isCandidate">
    <span class="mr-2" *ngIf="translationProposalService.isOn">{{ t("translationProposal.activated") }}</span>
    <i
      [pTooltip]="translationProposalService.isOn ? t('translationProposal.turnOff') : t('translationProposal.tooltip')"
      [class]="icon"
      (click)="onClick($event)"
      [style]="translationProposalService.canBeActivated || translationProposalService.isOn ? null : { color: 'gray' }"
    ></i>
  </ng-container>
</ng-container>
